var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C10.1645 1.49913 11.3131 1.76983 12.3547 2.29061C13.3963 2.81139 14.302 3.56788 15 4.5H12.9675C12.1014 3.73632 11.0334 3.23877 9.89154 3.06705C8.74969 2.89533 7.58255 3.05674 6.53017 3.53191C5.47778 4.00708 4.58486 4.77582 3.95855 5.74589C3.33224 6.71596 2.99915 7.84615 2.99925 9.00083C2.99934 10.1555 3.33262 11.2856 3.95909 12.2556C4.58557 13.2256 5.47861 13.9942 6.53108 14.4692C7.58354 14.9442 8.75071 15.1054 9.89252 14.9335C11.0343 14.7616 12.1023 14.2638 12.9683 13.5H15.0007C14.3027 14.4322 13.3968 15.1888 12.3551 15.7096C11.3134 16.2303 10.1646 16.501 9 16.5ZM14.25 12V9.75H8.25V8.25H14.25V6L18 9L14.25 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4992414cf4602f64cdb337c5364797ae.svg";
export { ForwardRef as ReactComponent };